import { render, staticRenderFns } from "./PromotionsMetadata.vue?vue&type=template&id=1afff80a"
import script from "./PromotionsMetadata.vue?vue&type=script&lang=js"
export * from "./PromotionsMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports